import React, { useRef, useState, useEffect } from 'react';
import { Overlay, Popover } from 'react-bootstrap';
import { getBasketList, GetProducts, addBasket, deleteBasket, GetLastProducts, getDiscountProduct, getFavoriteList, getAddToFavorite, deleteFavorite } from '../../utils/api';
import { Badge } from 'primereact/badge';
import './orders.css'
import { Skeleton } from 'primereact/skeleton';
import { useNavigate } from 'react-router-dom';
import Basket from '../../assets/icons/shop-card.svg'
import Hearth from '../../assets/icons/hearth.svg';
import ArrowLeft from '../../assets/icons/arrow-left-icon.svg'
import FactorData from '../../components/factor-data/factorData'
import Trash from '../../assets/icons/trash.svg';
import useToastNotification from '../../hooks/useToastNotification';
import { useCart } from '../../contexts/CartContext';
import ThreeLoader from '../../components/loader/threeDots'
import Tooltip from 'react-bootstrap/Tooltip';
import HeartBold from '../../assets/icons/heart-bold.svg';
import RedTrash from '../../assets/icons/red-trash.svg'
import ProductListSlider from '../../components/product-list-slider/productList'
const Orders = () => {
    const refs = useRef({}); // یک آبجکت برای ذخیره refs به صورت داینامیک

    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [factorDataSection, setFactorDataSection] = useState(false);
    const [target, setTarget] = useState(null);
    const ref = useRef(null);
    const [items, setItems] = useState([]);
    const [productsList, setProductsList] = useState([]);
    const [totalItems, setTotalItems] = useState('');
    const { showError, showSuccess } = useToastNotification();
    const { addToCart } = useCart();
    const [isLoading, setIsLoading] = useState(false);
    const [inputValues, setInputValues] = useState({});
    const typingTimers = useRef({});
    const [favoritList, setFavoritList] = useState({});


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setShow(false); // تابعی که overlay رو می‌بنده
            }
        };

        if (show) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [show]);
    const [loadingQuantities, setLoadingQuantities] = useState({});
    const [selectedDiscount, setSelectedDiscount] = useState(null);
    const openBasket = (event) => {
        fetchBasketList()
        setShow(!show);
        setTarget(event.target);
    };

    const closeBasket = () => {
        setShow(false);
    };
    const fetchBasketList = async (favoriteData) => {
        try {
            setIsLoading(true);
            const userId = JSON.parse(localStorage.getItem('userInfo')).si;
            const res = await getBasketList(userId);
            const basketData = res.data;

            const enrichedData = [];
            for (const item of basketData) {
                const discountRes = await getDiscountProduct(item.Id_Kala);
                enrichedData.push({
                    ...item,
                    discounts: discountRes.data,
                    favoriteId: favoriteData[item.Id_Kala]?.favoriteId || '',
                    isFavorit: favoriteData[item.Id_Kala]?.isFavorit || false,
                });
            }
            console.log(enrichedData)
            setItems(enrichedData);
        } catch (error) {
            console.error('Error fetching basket:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const changeFavorit = async (product) => {
        if (!JSON.parse(localStorage.getItem('userInfo'))) {
            window.location.hash = 'login';
            return;
        }
        if (!product.isFavorit) {
            let pay = {
                userId: JSON.parse(localStorage.getItem('userInfo')).si,
                productId: product.Id_Kala
            }
            await getAddToFavorite(pay)
            setItems(items.map(p =>
                p.Si === product.Si ? { ...p, isFavorit: true } : p
            ));
        } else {
            let pay = {
                UserId: JSON.parse(localStorage.getItem('userInfo')).si,
                productId: product.Id_Kala
            }
            await deleteFavorite(pay)
            setItems(items.map(p =>
                p.Si === product.Si ? { ...p, isFavorit: false } : p
            ));
        }
    }
    useEffect(() => {
        const fetchData = async () => {
            const favoriteData = await fetchFavorite()
            fetchBasketList(favoriteData)
        }
        fetchData()
    }, []);

    useEffect(() => {
    }, [items]);
    const getRef = (id) => {
        if (!refs.current[id]) {
            refs.current[id] = React.createRef();
        }
        return refs.current[id];
    };




    useEffect(() => {
        const fetch = async () => {
            await addToCart();
        };
        fetch();
    }, []);
    const fetchDiscountProduct = async (id, product) => {
        try {
            setShow(false); // مخفی کردن اولیه
            setSelectedDiscount(null); // پاک کردن مقدار قبلی برای جلوگیری از کش شدن

            const res = await getDiscountProduct(id);
            if (res.data.length > 0) {
                // setItems(prevItems =>
                //     prevItems.map(p =>
                //       p.Id_Kala === id ? { ...p, discounts: res.data } : p
                //     )
                //   );
                // checkDiscount(product,product.Nq)
                setTimeout(() => {

                    setSelectedDiscount({ id, discounts: res.data });
                    setShow(true); // نمایش تخفیف جدید
                }, 100); // تاخیر کوتاه برای اطمینان از به‌روز شدن مقدار
            } else {
                setSelectedDiscount(null);
                setShow(false);
            }
        } catch (error) {
            console.error('Error fetching discount:', error);
        }
    };
    const findProductBySi = (si) => {
        return items.find((p) => p.Si.toString() === si.toString());
    };

    // useEffect(() => {
    //     if (selectedDiscount && dialogContent.count) {
    //         checkDiscount(dialogContent.count);
    //     }
    // }, [selectedDiscount, dialogContent.count]);

    const handleIncrease = async (product, event) => {
        const newCount = product.Nq + 1;
        setInputValues((prevValues) => ({
            ...prevValues,
            [product.Si]: newCount,
        }));

        try {
            setLoadingQuantities(prev => ({ ...prev, [product.Si]: true }));
            let res = await addBasket({
                id: product.Id_Kala,
                count: newCount,
                userId: JSON.parse(localStorage.getItem('userInfo')).si
            });
            if (res.status == 200) {
                setTimeout(() => {
                    setLoadingQuantities(prev => ({ ...prev, [product.Si]: false }));
                }, 1000);
                setItems(items.map(p =>
                    p.Si === product.Si ? { ...p, Nq: newCount } : p
                ));
                addToCart()
            }

        } catch (error) {
            console.error('Error increasing product count:', error);
        }
    };

    const handleDecrease = async (product, event) => {
        const newCount = product.Nq - 1;


        try {
            setLoadingQuantities(prev => ({ ...prev, [product.Si]: true }));
            if (newCount >= product.MinOrder) {
                let res = await addBasket({
                    id: product.Id_Kala,
                    count: newCount,
                    userId: JSON.parse(localStorage.getItem('userInfo')).si
                });
                if (res.status == 200) {
                    setInputValues((prevValues) => ({
                        ...prevValues,
                        [product.Si]: newCount,
                    }));

                    setItems(items.map(p =>
                        p.Si === product.Si ? { ...p, Nq: newCount } : p
                    ));
                    setTimeout(() => {
                        setLoadingQuantities(prev => ({ ...prev, [product.Si]: false }));
                    }, 1000);

                }
            } else {
                let res = await deleteBasket({
                    userId: JSON.parse(localStorage.getItem('userInfo')).si,
                    id: product.Si
                });
                if (res.status == 200) {
                    setItems(items.filter(p => p.Si !== product.Si));

                    setTimeout(() => {
                        setLoadingQuantities(prev => ({ ...prev, [product.Si]: false }));
                    }, 1000);
                    addToCart();
                }


            }


        } catch (error) {
            console.error('Error decreasing product count:', error);
        }
    };
    const checkDiscount = (product, count) => {
        if (!product?.discounts?.length) return;

        for (const item of product.discounts) {
            const nq = item.Nq;
            if (nq) {
                if (nq.includes("از") && nq.includes("تا")) {
                    const match = nq.match(/از\s*(\d+)\s*تا\s*(\d+)/);
                    if (match) {
                        const from = parseInt(match[1]);
                        const to = parseInt(match[2]);
                        if (count >= from && count <= to) {
                            setItems(prevItems =>
                                prevItems.map(p =>
                                    p.Si === product.Si ? { ...p, DisCountPricePPP: item.Price, SumInvoice: (item.Price * count) } : p
                                )
                            );
                            break;
                        }
                    }
                } else if (nq.includes("بیشتراز")) {
                    const match = nq.match(/بیشتراز\s*(\d+)/);
                    if (match) {
                        const from = parseInt(match[1]);
                        if (count > from) {
                            setItems(prevItems =>
                                prevItems.map(p =>
                                    p.Si === product.Si ? { ...p, DisCountPricePPP: item.Price, SumInvoice: (item.Price * count) } : p
                                )
                            );
                            break;
                        }
                    }
                }
            }
        }
    };
    useEffect(() => {
    }, [items])
    const handleInputChange = (product, value) => {
        const si = product.Si.toString();
        const numericValue = value.replace(/\D/g, '');

        setInputValues(prev => ({
            ...prev,
            [si]: numericValue,
        }));

        // اگر تایمر قبلی وجود داره، حذف کن
        if (typingTimers.current[si]) {
            clearTimeout(typingTimers.current[si]);
        }

        // شروع تایمر جدید
        typingTimers.current[si] = setTimeout(() => {
            const productObj = findProductBySi(si);
            const parsed = parseInt(numericValue, 10);
            const finalCount = isNaN(parsed) || parsed < productObj.MinOrder ? productObj.MinOrder : parsed;

            setInputValues(prev => ({
                ...prev,
                [si]: finalCount.toString(),
            }));

            handleUpdateBasket(finalCount, productObj);

            // حذف تایمر پس از پایان
            delete typingTimers.current[si];
        }, 1200); // 1.2 ثانیه تأخیر
    };
    const handleUpdateBasket = async (newCount, product) => {

        try {
            setLoadingQuantities(prev => ({ ...prev, [product.Si]: true }));
            if (newCount >= product.MinOrder) {
                let res = await addBasket({ id: product.Id_Kala, count: newCount, userId: JSON.parse(localStorage.getItem('userInfo')).si });
                if (res.status == 200) {
                    setTimeout(() => {
                        setLoadingQuantities(prev => ({ ...prev, [product.Si]: false }));
                        checkDiscount(product, newCount)
                    }, 2000);
                    setItems(items.map(p =>
                        p.Si === product.Si ? { ...p, Nq: newCount } : p
                    ));
                }

            } else {
                let res = await deleteBasket({
                    userId: JSON.parse(localStorage.getItem('userInfo')).si,
                    id: product.BasketId
                });
                if (res.status == 200) {
                    setLoadingQuantities(prev => ({ ...prev, [product.Si]: false }));
                    setItems(items.map(p =>
                        p.Si === product.Si ? { ...p, Nq: 0 } : p
                    ));
                }

            }
        } catch (error) {
            console.error('Error updating basket:', error);
        }
    };

    const deleteItem = async (product) => {
        let res = await deleteBasket({
            userId: JSON.parse(localStorage.getItem('userInfo')).si,
            id: product.Si
        });
        if (res.status == 200) {
            setItems(items.filter(p => p.Si !== product.Si));

            setTimeout(() => {
                setLoadingQuantities(prev => ({ ...prev, [product.Si]: false }));
            }, 1000);
            addToCart();
        }
    }
    function convertToPersianNumbers(input) {
        if (input) {

            const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
            return input.replace(/\d/g, (digit) => persianDigits[digit]);
        }
    }
    const prevItemsRef = useRef([]); // ذخیره مقدار قبلی items

    useEffect(() => {
        // اگر items تغییر کرده و قبلاً مقدارش با مقدار جدید متفاوت است، چک کنیم
        if (JSON.stringify(prevItemsRef.current) !== JSON.stringify(items)) {
            items.forEach(item => {
                checkDiscount(item, item.Nq); // چک کردن تخفیف برای هر محصول
            });
            prevItemsRef.current = items; // به‌روز رسانی مقدار قبلی items
        }
    }, [items]); // فقط وقتی items تغییر کرد اجرا شود
    const fetchFavorite = async () => {
        try {
            const res = await getFavoriteList(JSON.parse(localStorage.getItem('userInfo')).si);
            const favoriteData = res.data.reduce((acc, item) => {
                acc[item.Id_Kala] = {
                    isFavorit: true,      // تعداد محصول در سبد خرید
                    favoriteId: item.Si // شناسه سبد خرید برای حذف یا ویرایش
                };
                return acc;
            }, {});
            setFavoritList(favoriteData);
            return favoriteData;
        } catch (error) {
            console.error('Error fetching basket:', error);
            return {};
        } finally {
        }
    };
    return (
        <>

            <div className='profile-card'>
                {!factorDataSection ? (
                    <div className=' d-flex  justify-content-between align-items-center mx-2'>
                        <h6 className='page-title my-4'>سبد خرید</h6>
                        <div className='text-center d-flex justify-content-center'>
                            <button className='btn btn-primary  d-flex align-items-center justify-content-between w-[130px]' onClick={() => setFactorDataSection(true)}>ادامه خرید <img src={ArrowLeft} alt="" /></button>

                        </div>
                    </div>
                ) : (<div className=' d-flex  justify-content-between align-items-center mx-2'>
                    <h6 className='page-title my-4'>حساب کاربری</h6>
                    <div className='text-center d-flex justify-content-center'>
                        <button className='btn btn-primary  d-flex align-items-center justify-content-between w-[130px]' onClick={() => setFactorDataSection(false)}>بازگشت <img src={ArrowLeft} alt="" /></button>

                    </div>
                </div>)}

                {isLoading ? (<div className='mt-4'>

                    <div className="skeleton-wrapper gy-3 row web-selekton">
                        {[...Array(6)].map((_, index) => (
                            <div className='col-12 col-md-6'>
                                <div className='product-item d-flex  gap-3 flex-col-ipad' >
                                    <div className='product-img aspect-[4/4]'>
                                        <Skeleton className='img-product h-100' alt="Image 1" />
                                    </div>
                                    <div className='detail-text'>
                                        <div className='detail w-50 '>
                                            <Skeleton className='mt-1' />
                                            <Skeleton className='mt-4 number-font' width='100px' />
                                            <Skeleton className='mt-2 number-font' width='120px' />
                                            <Skeleton className='mt-2 number-font' width='140px' />
                                        </div>

                                        <div className='d-flex align-items-center gap-2 mt-4'>
                                            <Skeleton height='40px' width='40px' className='btn btn-primary  h-[48px]' />
                                            <Skeleton height='40px' width='40px' />
                                            <Skeleton height='40px' width='40px' className='btn btn-primary  h-[48px]' />
                                            {/* )} */}
                                        </div>

                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="skeleton-wrapper container row gy-3  mobile-selekton px-0">
                        {[...Array(6)].map((_, index) => (
                            <div className='col-12 col-md-6 col-lg-6'>
                                <div className='product-item d-flex  gap-3 flex-col-ipad' >
                                    <div className='product-img aspect-[4/4]'>
                                        <Skeleton className='img-product h-100 aspect-[4/4]' alt="Image 1" />
                                    </div>
                                    <div className='detail-text'>
                                        <div className='detail w-50 '>
                                            <Skeleton className='mt-1' />
                                            <Skeleton className='mt-4 number-font' width='100px' />
                                            <Skeleton className='mt-2 number-font' width='120px' />
                                            <Skeleton className='mt-2 number-font' width='140px' />
                                        </div>

                                        <div className='d-flex align-items-center gap-2 mt-4'>
                                            <Skeleton height='32px' width='32px' className='btn btn-primary  h-[48px]' />
                                            <Skeleton height='32px' width='32px' />
                                            <Skeleton height='32px' width='32px' className='btn btn-primary  h-[48px]' />
                                            {/* )} */}
                                        </div>

                                    </div>
                                </div>
                            </div>

                        ))}
                    </div>
                </div>) : (
                    <>
                        {items.length > 0 ? (
                            <>
                                {
                                    factorDataSection ? (
                                        <>
                                            <FactorData />
                                        </>
                                    ) : (
                                        <>
                                            <div className='row mx-auto gy-3 mt-4'>
                                                {
                                                    items.length > 0 && items.map((product, index) => (
                                                        <div className='col-12 col-md-6 col-lg-6' key={index}>
                                                            <div className='product-item d-flex  gap-3 flex-col-ipad'
                                                            >
                                                                <div className='delete-box' onClick={(e) => deleteItem(product)}>
                                                                    <img src={RedTrash} alt="" />
                                                                </div>
                                                                <div className='product-img aspect-[4/4]'>
                                                                    <img src={product.Pic_A} className='img-box img-product' alt={product.KalaName} />
                                                                    <img src={product.isFavorit ? HeartBold : Hearth} className='favorite-icon' alt="" onClick={(e) => { e.stopPropagation(); changeFavorit(product) }} />
                                                                </div>
                                                                <div className='detail-text'>
                                                                    <div className='detail'>
                                                                        <h4 className='font-semibold'>{convertToPersianNumbers(product.KalaName)}</h4>
                                                                        <div className='d-flex align-items-center gap-3 justify-content-between'>
                                                                            <h5 className={`${(product.DisCountPricePPP && product.DisCountPricePPP != product.Price) ? 'discount-price' : ''} mt-2 number-font`}>{parseInt(product.Price).toLocaleString()} تومان</h5>
                                                                            {(product.DisCountPricePPP && product.DisCountPricePPP != product.Price) && (

                                                                                <h5 className='mt-2 number-font'>{parseInt(product.DisCountPricePPP).toLocaleString()} تومان</h5>
                                                                            )}
                                                                        </div>
                                                                        <h6 className='text-sm mb-0 number-font' style={{ color: '#242526', direction: 'rtl', fontSize: '10px' }}>قیمت کل : {parseInt(product.SumInvoice).toLocaleString()} تومان</h6>
                                                                    </div>

                                                                    <span className='f-10'>حداقل تعداد خرید محصول {convertToPersianNumbers((product.MinOrder).toString())} عدد</span>
                                                                    <div >
                                                                        <div className='text-center d-flex w-fit'>
                                                                            <div className='d-flex align-items-center  mt-4 gap-2 increas  w-fit'>
                                                                                <button className='btn btn-primary ' style={{ width: '40px', height: '40px', fontSize: '10px' }} onClick={() => handleIncrease(product)} >+</button>
                                                                                {loadingQuantities[product.Si] ? (
                                                                                    <div className='form-control  text-center d-flex align-items-center justify-content-center' style={{ width: '48px', height: '40px' }}>
                                                                                        <ThreeLoader />

                                                                                    </div>
                                                                                ) : (
                                                                                    <input
                                                                                        className={`form-control  text-center number-font`}
                                                                                        style={{ height: '40px', width: '40px' }}
                                                                                        value={inputValues[product.Si] ?? product.Nq}
                                                                                        onChange={(e) => handleInputChange(product, e.target.value)}
                                                                                        onMouseEnter={async () => {
                                                                                            setSelectedDiscount(null)
                                                                                            await fetchDiscountProduct(product.Id_Kala, product)
                                                                                        }}
                                                                                    />
                                                                                )}



                                                                                <button ref={getRef(product.Si)} className='btn btn-primary w-[32px] d-flex align-items-center justify-center' style={{ width: '40px', height: '40px' }} onClick={() => handleDecrease(product)}>
                                                                                    {product.Nq === product.MinOrder ? <img src={Trash} width={18} /> : '-'}
                                                                                </button>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                    {selectedDiscount?.id === product.Id_Kala && selectedDiscount?.discounts.length > 0 && (
                                                                        <div ref={ref}>
                                                                            <Overlay
                                                                                target={getRef(product.Si).current}
                                                                                show={show && selectedDiscount?.id === product.Id_Kala}
                                                                                placement="left"
                                                                            >
                                                                                {(props) => (
                                                                                    <Tooltip id="overlay-example" {...props}>
                                                                                        <div className="discount-list">
                                                                                            {selectedDiscount.discounts.map((discount, index) => (
                                                                                                <div key={index} className="discount-item">
                                                                                                    <span className="number-font">{discount.Nq ?? ''}</span>
                                                                                                    <span className="number-font">{discount.Price?.toLocaleString() ?? ''} تومان</span>
                                                                                                </div>
                                                                                            ))}
                                                                                        </div>
                                                                                    </Tooltip>
                                                                                )}
                                                                            </Overlay>
                                                                        </div>

                                                                    )}
                                                                </div>

                                                            </div>

                                                        </div>

                                                    ))
                                                }
                                            </div>


                                        </>
                                    )
                                }

                            </>
                        ) : (
                            <>
                                هیچ محصولی در سبد خرید شما وجود ندارد.
                            </>
                        )}
                    </>
                )}


            </div>
            {/* <ProductListSlider productsData={productsList}/> */}
        </>

    );
};

export default Orders;
